export function roundTimeQuarterHour(time) {
    var timeToReturn = new Date(time);

    timeToReturn.setMilliseconds(Math.ceil(timeToReturn.getMilliseconds() / 1000) * 1000);
    timeToReturn.setSeconds(Math.ceil(timeToReturn.getSeconds() / 60) * 60);
    // timeToReturn.setMinutes(Math.ceil(timeToReturn.getMinutes() / 15) * 15);
    timeToReturn.setMinutes(Math.ceil(timeToReturn.getMinutes() / 60) * 60); //Cambio para que se incremente de hora en hora
    return timeToReturn;
}
